import type { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd';
import { createContext, useContext, type ReactNode } from 'react';

/**
 * Props spread on a wrapper inside a @hello-pangea/dnd drag handle so the inner
 * node is not treated as the full drag handle (fixes SearchSelect blur/selection under DnD).
 */
export interface MarketCardRfdDragIslandProps {
  'data-rfd-drag-handle-context-id': DraggableProvidedDragHandleProps['data-rfd-drag-handle-context-id'];
}

const MarketCardRfdDragContext = createContext<MarketCardRfdDragIslandProps | undefined>(undefined);

export function getMarketCardRfdDragIslandProps(
  dragHandleProps: DraggableProvidedDragHandleProps | null | undefined
): MarketCardRfdDragIslandProps | undefined {
  if (dragHandleProps == null) {
    return undefined;
  }
  return { 'data-rfd-drag-handle-context-id': dragHandleProps['data-rfd-drag-handle-context-id'] };
}

export function MarketCardRfdDragProvider({
  dragHandleProps,
  children,
}: {
  dragHandleProps?: DraggableProvidedDragHandleProps | null;
  children: ReactNode;
}) {
  const value = getMarketCardRfdDragIslandProps(dragHandleProps);
  return <MarketCardRfdDragContext.Provider value={value}>{children}</MarketCardRfdDragContext.Provider>;
}

export function useMarketCardRfdDragIslandProps(): MarketCardRfdDragIslandProps | undefined {
  return useContext(MarketCardRfdDragContext);
}
